var exports = {
  "kL": "xfb577c5e--9f526d--container",
  "qT": "xfb577c5e--9f526d--features",
  "N4": "xfb577c5e--9f526d--feature",
  "h_": "xfb577c5e--9f526d--description",
  "cy": "xfb577c5e--9f526d--author",
  "Y4": "xfb577c5e--9f526d--author-content",
  "mW": "xfb577c5e--9f526d--newbuilding-list",
  "Qo": "xfb577c5e--9f526d--bank-list",
};

module.exports = exports;
